/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Photo_PoolInputs */

const en_photo_pool = /** @type {(inputs: Photo_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photo Pool`)
};

const es_photo_pool = /** @type {(inputs: Photo_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batería de fotos`)
};

const fr_photo_pool = /** @type {(inputs: Photo_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réserve de photos`)
};

const de_photo_pool = /** @type {(inputs: Photo_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto-Pool`)
};

const ja_photo_pool = /** @type {(inputs: Photo_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォトプール`)
};

const zh_photo_pool = /** @type {(inputs: Photo_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`照片池`)
};

const ar_photo_pool = /** @type {(inputs: Photo_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مجموعة الصور`)
};

const id_photo_pool = /** @type {(inputs: Photo_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kumpulan Foto`)
};

const it_photo_pool = /** @type {(inputs: Photo_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raccolta foto`)
};

const ru_photo_pool = /** @type {(inputs: Photo_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пул фотографий`)
};

const pt_photo_pool = /** @type {(inputs: Photo_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Banco de fotos`)
};

const ko_photo_pool = /** @type {(inputs: Photo_PoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사진 풀`)
};

/**
* | output |
* | --- |
* | "Photo Pool" |
*
* @param {Photo_PoolInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const photo_pool = /** @type {((inputs?: Photo_PoolInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Photo_PoolInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_photo_pool(inputs)
	if (locale === "es") return es_photo_pool(inputs)
	if (locale === "fr") return fr_photo_pool(inputs)
	if (locale === "de") return de_photo_pool(inputs)
	if (locale === "ja") return ja_photo_pool(inputs)
	if (locale === "zh") return zh_photo_pool(inputs)
	if (locale === "ar") return ar_photo_pool(inputs)
	if (locale === "id") return id_photo_pool(inputs)
	if (locale === "it") return it_photo_pool(inputs)
	if (locale === "ru") return ru_photo_pool(inputs)
	if (locale === "pt") return pt_photo_pool(inputs)
	return ko_photo_pool(inputs)
});